{
 "name": "0_plant_mushroom5",
 "bin": "0_plant_mushroom5.bin",
 "nodes": [
  {"name": "", "parent": -1, "t": [0,0,0], "q": [0,0,0,1], "s": [1,1,1]},
  {"name": "Fbx_Root", "parent": 0, "t": [0,0,0], "q": [-0.7071068,0,0,0.7071068], "s": [0.0254,0.0254,0.0254]},
  {"name": "Producer Perspective", "parent": 0, "t": [0,0.713,2.875], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Top", "parent": 0, "t": [0,40,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Bottom", "parent": 0, "t": [0,-40,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Front", "parent": 0, "t": [0,0,40], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Back", "parent": 0, "t": [0,0,-40], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Right", "parent": 0, "t": [40,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Left", "parent": 0, "t": [-40,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Camera Switcher", "parent": 0, "t": [0,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "0_plant_mushroom5", "parent": 1, "t": [-2.355854,-25.79626,0], "q": [-0.7069844,-0.002802851,-0.002568292,0.707219], "s": [1.2,1.2,1.2]},
  {"name": "", "parent": 10, "t": [1.883873,0.01960288,16.02468], "q": [0,0,0,1], "s": [1,1,1]},
  {"name": "Sphere01", "parent": 10, "t": [1.883873,0.01960246,29.02737], "q": [0.04357595,-0.04324689,-0.001917195,0.9981118], "s": [1,1,0.6729034]},
  {"name": "Capsule01", "parent": 10, "t": [1.883873,0.01960097,-12.02459], "q": [0,0,0,1], "s": [1,1,1]}
 ],
 "parts": [
  {"node": 12, "vertexCount": 162, "posOffset": 0, "nrmOffset": 1944, "uvOffset": 3888, "material": "0_plant_mushroom5", "color": [0.8863,0.8863,0.8863,1], "texture": "0_plant_mushroom5.png"},
  {"node": 13, "vertexCount": 75, "posOffset": 5184, "nrmOffset": 6084, "uvOffset": 6984, "material": "0_plant_mushroom1_stiel", "color": [1,1,1,1]}
 ],
 "anims": [
  {"name": "die", "duration": 0.8, "fps": 30, "frames": 25, "offset": 7584},
  {"name": "grow", "duration": 3.3, "fps": 30, "frames": 100, "offset": 21584},
  {"name": "idle", "duration": 0.36667, "fps": 30, "frames": 12, "offset": 77584},
  {"name": "pick", "duration": 0.96667, "fps": 30, "frames": 30, "offset": 84304}
 ]
}
